module.exports = __webpack_public_path__ + "img/cy.2976ae03.jpg";